import { render, staticRenderFns } from "./SchoolSpecial.vue?vue&type=template&id=0f3f92ee&scoped=true&"
import script from "./SchoolSpecial.vue?vue&type=script&lang=js&"
export * from "./SchoolSpecial.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSpecial.vue?vue&type=style&index=0&id=0f3f92ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3f92ee",
  null
  
)

export default component.exports